<template>
    <div class="animate-on-scroll-settings">

        <div class="setting">
            <b-form-group>

                <label>Animation type:</label>
                <b-form-select v-model="settingsFromWeebly.settings.animationName" size="sm">
                    <option disabled>FADE ANIMATIONS</option>
                    <option value="fade">Fade</option>
                    <option value="fade-up" selected>Fade Up</option>
                    <option value="fade-down">Fade Down</option>
                    <option value="fade-left">Fade Left</option>
                    <option value="fade-right">Fade Right</option>
                    <option value="fade-up-right">Fade Up Right</option>
                    <option value="fade-up-left">Fade Up Left</option>
                    <option value="fade-down-right">Fade Down Right</option>
                    <option value="fade-down-left">Fade Down Left</option>
                    <option disabled>FLIP ANIMATIONS</option>
                    <option value="flip-up">Flip Up</option>
                    <option value="flip-down">Flip Down</option>
                    <option value="flip-left">Flip Left</option>
                    <option value="flip-right">Flip Right</option>
                    <option disabled>ZOOM ANIMATIONS</option>
                    <option value="zoom-in">Zoom In</option>
                    <option value="zoom-in-up">Zoom In Up</option>
                    <option value="zoom-in-down">Zoom In Down</option>
                    <option value="zoom-in-left">Zoom In Left</option>
                    <option value="zoom-in-right">Zoom In Right</option>
                    <option value="zoom-out">Zoom Out</option>
                    <option value="zoom-out-up">Zoom Out Up</option>
                    <option value="zoom-out-down">Zoom Out Down</option>
                    <option value="zoom-out-left">Zoom Out Left</option>
                    <option value="zoom-out-right">Zoom Out Right</option>
                </b-form-select>

            </b-form-group>
        </div>

        <div class="setting">
            <b-form-group>
                <label>Animation delay:</label>
                <b-form-select v-model="settingsFromWeebly.settings.animationDelay" size="sm">
                    <option value="0">No delay</option>
                    <option value="250">1/4 second (250ms)</option>
                    <option value="500">1/2 second (500ms)</option>
                    <option value="750">3/4 second (750ms)</option>
                    <option value="1000">1 second (1000ms)</option>
                    <option value="1500">1.5 second (1500ms)</option>
                    <option value="2000">2 seconds (2000ms)</option>
                    <option value="3000">3 seconds (3000ms)</option>
                </b-form-select>
            </b-form-group>
        </div>

        <div class="setting">
            <b-form-group>
                <label>Animation duration:</label>
                <b-form-select v-model="settingsFromWeebly.settings.animationDuration" size="sm">
                    <option value="250">Extra Fast (250ms)</option>
                    <option value="500">Fast (500ms)</option>
                    <option value="750">Medium Fast (750ms)</option>
                    <option value="1000" selected>Normal (1000ms)</option>
                    <option value="1500">Medium Slow (1500ms)</option>
                    <option value="2000">Slow (2000ms)</option>
                    <option value="3000">Extra Slow (3000ms)</option>
                </b-form-select>
            </b-form-group>
        </div>

        <div class="setting">
            <b-form-group>
                <label>Activation point:  <i style="margin-left:7px;" class="far fa-question-circle" v-b-tooltip.hover="{title: 'The element\'s position relative to the window, e.g. top-center: when top of the element reaches the center of the window. ', placement: 'top', boundary: 'window'}"></i></label>
                <b-form-select v-model="settingsFromWeebly.settings.animationAnchor" size="sm">
                    <option value="top-bottom">top-bottom</option>
                    <option value="top-center">top-center</option>
                    <option value="top-top">top-top</option>
                    <option value="center-bottom">center-bottom</option>
                    <option value="center-center">center-center</option>
                    <option value="center-top">center-top</option>
                    <option value="bottom-bottom">bottom-bottom</option>
                    <option value="bottom-center">bottom-center</option>
                    <option value="bottom-top">bottom-top</option>
                </b-form-select>
            </b-form-group>
        </div>

        


    </div>
</template>

<script>

export default {

    name: 'AnimateOnScrollSettings',

    data() {
        return {
            errorInString: false
        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        }

    },

    mounted() {

    },

    components: {

    },

    methods: {
        
        
    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';

</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/AnimateOnScrollSettings.vue